(function () {
  if (window.__llImageEditorLoaded) return;
  window.__llImageEditorLoaded = true;

  function qs(root, selector) { return root ? root.querySelector(selector) : null; }
  function qsa(root, selector) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function sanitizeFilename(name) {
    var base = (name || 'photo').replace(/\.[^.]+$/, '');
    return base.toLowerCase().replace(/[^a-z0-9-_]+/g, '-').replace(/^-+|-+$/g, '') || 'photo';
  }

  /* Stage 7B: preserve the customer's original crystal photo while navigating
     between the separate Shopify product pages used by the shape selector. */
  var MAIN_PHOTO_TRANSFER_DB = 'll-main-photo-transfer-v1';
  var MAIN_PHOTO_TRANSFER_STORE = 'photos';
  var MAIN_PHOTO_TRANSFER_KEY = 'current-crystal-photo';
  var MAIN_PHOTO_TRANSFER_MAX_AGE = 2 * 60 * 60 * 1000;

  function openMainPhotoTransferDb() {
    return new Promise(function (resolve, reject) {
      if (!window.indexedDB) {
        reject(new Error('Browser photo storage is unavailable.'));
        return;
      }

      var request;
      try { request = window.indexedDB.open(MAIN_PHOTO_TRANSFER_DB, 1); }
      catch (err) { reject(err); return; }

      request.onupgradeneeded = function () {
        var db = request.result;
        if (!db.objectStoreNames.contains(MAIN_PHOTO_TRANSFER_STORE)) {
          db.createObjectStore(MAIN_PHOTO_TRANSFER_STORE, { keyPath: 'key' });
        }
      };
      request.onsuccess = function () { resolve(request.result); };
      request.onerror = function () { reject(request.error || new Error('Could not open browser photo storage.')); };
    });
  }

  function writeMainPhotoTransfer(record) {
    return openMainPhotoTransferDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx;
        try { tx = db.transaction(MAIN_PHOTO_TRANSFER_STORE, 'readwrite'); }
        catch (err) { db.close(); reject(err); return; }
        tx.oncomplete = function () { db.close(); resolve(record); };
        tx.onerror = function () { var error = tx.error || new Error('Could not store the photo.'); db.close(); reject(error); };
        tx.objectStore(MAIN_PHOTO_TRANSFER_STORE).put(record);
      });
    });
  }

  function readMainPhotoTransfer() {
    return openMainPhotoTransferDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx;
        try { tx = db.transaction(MAIN_PHOTO_TRANSFER_STORE, 'readonly'); }
        catch (err) { db.close(); reject(err); return; }
        var request = tx.objectStore(MAIN_PHOTO_TRANSFER_STORE).get(MAIN_PHOTO_TRANSFER_KEY);
        request.onsuccess = function () { db.close(); resolve(request.result || null); };
        request.onerror = function () { var error = request.error || new Error('Could not restore the photo.'); db.close(); reject(error); };
      });
    });
  }

  function removeMainPhotoTransfer() {
    return openMainPhotoTransferDb().then(function (db) {
      return new Promise(function (resolve) {
        var tx;
        try { tx = db.transaction(MAIN_PHOTO_TRANSFER_STORE, 'readwrite'); }
        catch (err) { db.close(); resolve(); return; }
        tx.oncomplete = function () { db.close(); resolve(); };
        tx.onerror = function () { db.close(); resolve(); };
        tx.objectStore(MAIN_PHOTO_TRANSFER_STORE).delete(MAIN_PHOTO_TRANSFER_KEY);
      });
    }).catch(function () {});
  }

  var SHAPE_CONFIG = {
    default:   { aspectRatio: 0.72,   imageZone: { x: 0.18,   y: 0.08,   w: 0.64,   h: 0.82   } },
    tower:     { aspectRatio: 0.6480, imageZone: { x: 0.2608, y: 0.1284, w: 0.4801, h: 0.7408 } },
    brick:     { aspectRatio: 1.4408, imageZone: { x: 0.1172, y: 0.2831, w: 0.7663, h: 0.5319 } },
    heart:     { aspectRatio: 1.0680, imageZone: { x: 0.1348, y: 0.1396, w: 0.7265, h: 0.6802 } },
    prestige:  { aspectRatio: 0.7060, imageZone: { x: 0.2233, y: 0.1108, w: 0.5630, h: 0.7974 } },
    diamond:   { aspectRatio: 1.0319, imageZone: { x: 0.1300, y: 0.1332, w: 0.7480, h: 0.7249 } },
    square:    { aspectRatio: 1.0100, imageZone: { x: 0.1372, y: 0.1499, w: 0.7265, h: 0.7193 } },
    urn:       { aspectRatio: 1.0967, imageZone: { x: 0.0774, y: 0.2368, w: 0.6332, h: 0.5774 } },
    paw:       { aspectRatio: 1.0478, imageZone: { x: 0.1276, y: 0.1324, w: 0.7520, h: 0.7177 } },
    flat:      { aspectRatio: 0.8949, imageZone: { x: 0.2318, y: 0.0766, w: 0.5285, h: 0.7380 } },
    rectangle: { aspectRatio: 0.6480, imageZone: { x: 0.2608, y: 0.1284, w: 0.4801, h: 0.7408 } },
    cube:      { aspectRatio: 1.0100, imageZone: { x: 0.1372, y: 0.1499, w: 0.7265, h: 0.7193 } },
    circle:    { aspectRatio: 1.0680, imageZone: { x: 0.1348, y: 0.1396, w: 0.7265, h: 0.6802 } },

    /* Stage 6P: exact transparent photo zones for the 13 accessory masks. */
    'accessory-wine-stopper-octagon':   { aspectRatio: 0.997647, imageZone: { x: 0.290039, y: 0.050781, w: 0.414062, h: 0.415039 } },
    'accessory-wine-stopper-square':    { aspectRatio: 1.052239, imageZone: { x: 0.330941, y: 0.047847, w: 0.337321, h: 0.320574 } },
    'accessory-wine-stopper-round':     { aspectRatio: 1.064240, imageZone: { x: 0.299043, y: 0.034290, w: 0.396332, h: 0.372408 } },
    'accessory-wine-stopper-rectangle': { aspectRatio: 0.942350, imageZone: { x: 0.331738, y: 0.032695, w: 0.338915, h: 0.359649 } },
    'accessory-keychain-brick':         { aspectRatio: 1.451685, imageZone: { x: 0.274414, y: 0.433816, w: 0.630859, h: 0.429952 } },
    'accessory-keychain-heart':         { aspectRatio: 0.825397, imageZone: { x: 0.464844, y: 0.333008, w: 0.406250, h: 0.492188 } },
    'accessory-keychain-tower':         { aspectRatio: 0.678843, imageZone: { x: 0.454545, y: 0.380383, w: 0.355662, h: 0.523923 } },
    'accessory-necklace-oval':          { aspectRatio: 0.881838, imageZone: { x: 0.296875, y: 0.376953, w: 0.393555, h: 0.446289 } },
    'accessory-necklace-heart':         { aspectRatio: 0.926931, imageZone: { x: 0.279297, y: 0.346680, w: 0.433594, h: 0.467773 } },
    'accessory-necklace-square':        { aspectRatio: 0.792517, imageZone: { x: 0.272461, y: 0.344727, w: 0.455078, h: 0.574219 } },
    'accessory-ornament-heart':         { aspectRatio: 1.153425, imageZone: { x: 0.155502, y: 0.244019, w: 0.671451, h: 0.582137 } },
    'accessory-ornament-round':         { aspectRatio: 1.000000, imageZone: { x: 0.218501, y: 0.245614, w: 0.555821, h: 0.555821 } },
    'accessory-ornament-house':         { aspectRatio: 0.952685, imageZone: { x: 0.204147, y: 0.271132, w: 0.594099, h: 0.623604 } }
  };

  function getShapeConfig(shape) {
    var key = String(shape || 'default').toLowerCase();
    return SHAPE_CONFIG[key] || SHAPE_CONFIG.default;
  }


  var ENGRAVING_POSITIONS = {
    tower:    { x: 49.6, y: 83.7, w: 39.3, size: 17.0, lineHeight: 1.16, rotate: 0.0 },
    brick:    { x: 50.0, y: 77.1, w: 46.0, size: 17.0, lineHeight: 1.13, rotate: 0.0 },
    heart:    { x: 50.0, y: 72.2, w: 32.0, size: 15.0, lineHeight: 1.12, rotate: 0.0 },
    prestige: { x: 48.6, y: 86.4, w: 34.0, size: 15.0, lineHeight: 1.12, rotate: 0.0 },
    diamond:  { x: 50.0, y: 70.0, w: 30.0, size: 14.0, lineHeight: 1.12, rotate: 0.0 },
    square:   { x: 50.0, y: 84.2, w: 36.0, size: 17.2, lineHeight: 1.12, rotate: 0.0 },
    urn:      { x: 38.0, y: 76.6, w: 38.0, size: 14.0, lineHeight: 1.12, rotate: 0.0 },
    paw:      { x: 50.0, y: 74.9, w: 40.0, size: 15.0, lineHeight: 1.12, rotate: 0.0 },
    flat:     { x: 50.0, y: 73.9, w: 36.0, size: 17.0, lineHeight: 1.12, rotate: 0.0 },
    default:  { x: 50.0, y: 83.7, w: 39.3, size: 17.0, lineHeight: 1.12, rotate: 0.0 }
  };

  function getEngravingPosition(shapeKey) {
    return ENGRAVING_POSITIONS[String(shapeKey || 'default').toLowerCase()] || ENGRAVING_POSITIONS.default;
  }

  function normalizeEngravingText(text) {
    return String(text || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim();
  }

  function setFiles(input, files) {
    if (!input || !files || !files.length) return false;
    try {
      var dt = new DataTransfer();
      files.forEach(function (file) { dt.items.add(file); });
      input.files = dt.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    } catch (err) { return false; }
  }

  function showText(el, message) {
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  var imageCache = {};
  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      if (!url) { resolve(null); return; }
      if (imageCache[url] && imageCache[url].complete) { resolve(imageCache[url]); return; }
      var img = new Image();
      /* Stage 7N: Shopify may serve theme assets from a CDN origin that differs
         from the storefront/preview origin. Once those images are drawn into a
         canvas, mobile browsers are stricter about canvas export unless the
         image was loaded with anonymous CORS enabled. */
      if (/^(?:https?:)?\/\//i.test(url)) img.crossOrigin = 'anonymous';
      imageCache[url] = img;
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('Could not load image asset.')); };
      img.src = url;
    });
  }



  function makeCustomizationId() {
    return '3dll-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function appendCloudflareUpload(formData, file, fileName, kind, customizationId) {
    formData.append('file', file, fileName || (kind + '.png'));
    formData.append('kind', kind || 'image');
    formData.append('customization_id', customizationId);
  }

  function uploadToCloudflare(endpoint, file, fileName, kind, customizationId) {
    if (!endpoint) return Promise.reject(new Error('Cloudflare upload endpoint is missing.'));
    if (!file) return Promise.reject(new Error('Missing image file.'));

    var body = new FormData();
    appendCloudflareUpload(body, file, fileName, kind, customizationId);

    return fetch(endpoint, {
      method: 'POST',
      body: body,
      credentials: 'omit',
      headers: { 'Accept': 'application/json' }
    }).catch(function (err) {
      throw new Error((err && err.message) ? err.message : 'Cloudflare upload request failed.');
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (!res.ok || !json || !json.ok || !json.url) {
          throw new Error((json && (json.error || json.message)) || 'Cloudflare upload failed.');
        }
        return json;
      });
    });
  }

  function getNaturalSize(img) {
    if (!img) return null;
    return {
      width: img.naturalWidth || img.width || 1,
      height: img.naturalHeight || img.height || 1
    };
  }

  function initEditor(root) {
    var form = root.closest('form[action^="/cart/add"]') || document.getElementById('AddToCartForm');
    var originalInput = qs(root, '[data-ll-editor-original-input]');
    var editedInput = qs(root, '[data-ll-editor-edited-input]');
    var trigger = qs(root, '[data-ll-editor-upload-trigger]');
    var editAgain = qs(root, '[data-ll-editor-edit-again]');
    var statusText = qs(root, '[data-ll-editor-status-text]');
    var modal = qs(root, '[data-ll-editor-modal]');
    var editorImage = qs(root, '[data-ll-editor-image]');
    var maskGuide = qs(root, '[data-ll-editor-mask-guide]');
    var saveBtn = qs(root, '[data-ll-editor-save]');
    var photoName = qs(root, '[data-ll-photo-name]');
    var statusInput = qs(root, '[data-ll-editor-status]');
    var customizationIdInput = qs(root, '[data-ll-customization-id]');
    var originalUrlInput = qs(root, '[data-ll-original-photo-url]');
    var previewUrlInput = qs(root, '[data-ll-preview-photo-url]');
    var previewUrlPrivateInput = qs(root, '[data-ll-preview-photo-url-private]');
    var previewUrlAppInput = qs(root, '[data-ll-preview-photo-url-app]');
    var cropDataInput = qs(root, '[data-ll-crop-data-input]');
    var rotationInput = qs(root, '[data-ll-rotation-input]');
    var zoomInput = qs(root, '[data-ll-zoom-input]');
    var inlineError = qs(root, '[data-ll-editor-inline-error]');
    var modalError = qs(root, '[data-ll-editor-error]');
    var shape = root.getAttribute('data-ll-editor-shape') || 'default';
    var backgroundAsset = root.getAttribute('data-ll-editor-background') || '';
    var maskAsset = root.getAttribute('data-ll-editor-mask') || '';
    var isSecondary = root.getAttribute('data-ll-editor-secondary') === 'true';
    var isAccessoryEditor = root.getAttribute('data-ll-editor-accessory') === 'true';
    var cloudflareUploadEndpoint = root.getAttribute('data-ll-cloudflare-upload-endpoint') || 'https://3dlaserland-customizer-worker.3dllcloudflare.workers.dev/upload';
    var cropper = null;
    var originalFile = null;
    var objectUrl = '';
    var rotationDeg = 0;
    var zoomPercent = 100;
    var savedPreviewUrl = '';
    var customizationId = makeCustomizationId();
    var originalCloudUrl = '';
    var previewCloudUrl = '';
    var saved = false;
    var cartSubmitInProgress = false;
    var transferredPlacement = null;
    var cropperBootToken = 0;
    var livePreviewCanvas = null;
    var livePreviewFrame = 0;
    var livePreviewTimer = 0;
    var livePreviewLastRender = 0;
    var livePreviewInteracting = false;
    var automaticTransferBaseCanvas = null;
    /* Stage 7AB: the saved product preview must come from the same CURRENT
       Cropper frame the customer sees. Keep the finished composite in memory so
       Add to Cart never re-crops/repositions the photo after Save Photo. */
    var savedCompositeCanvas = null;

    /* Stage 7AA: preserve the customer's exact editor framing independently of
       mobile viewport/layout changes. Mobile Safari/Chrome can fire resize
       events when browser chrome expands/collapses; the old resize path
       re-locked Cropper's crop box and could subtly change x/y/zoom after the
       customer had finished positioning the photo. */
    var committedCropData = null;
    var lastEditorViewportWidth = 0;

    /* Stage 7F: cross-shape transfers use an explicit one-to-one pointer drag.
       Cropper's built-in move action can inherit an incorrect movement ratio
       after a restored Blob/canvas is re-fitted to a differently shaped crop
       box. The saved crop remains correct, but a small pointer movement can
       move through a much larger portion of the source image. */
    var useDirectTransferDrag = false;
    var directDragState = null;

    if (!form || !originalInput || !trigger || !modal || !editorImage || !saveBtn) return;
    if (customizationIdInput) customizationIdInput.value = customizationId;

    function getMainPhotoTransferMetadata() {
      if (isSecondary || !originalFile) return null;
      return {
        key: MAIN_PHOTO_TRANSFER_KEY,
        version: 1,
        savedAt: Date.now(),
        fileName: originalFile.name || 'photo.jpg',
        fileType: originalFile.type || 'image/jpeg',
        lastModified: originalFile.lastModified || Date.now(),
        originalCloudUrl: originalCloudUrl || '',
        sourceShape: shape || 'default',
        cropData: cropDataInput ? cropDataInput.value || '' : '',
        rotation: rotationInput ? rotationInput.value || '0' : String(rotationDeg || 0),
        zoom: zoomInput ? zoomInput.value || '100' : String(zoomPercent || 100),
        customizationId: customizationId || '',
        wasSaved: !!saved
      };
    }

    function prepareMainPhotoTransfer() {
      var metadata = getMainPhotoTransferMetadata();
      if (!metadata || !originalFile) return Promise.reject(new Error('There is no photo to carry to the next shape.'));

      var record = {};
      Object.keys(metadata).forEach(function (key) { record[key] = metadata[key]; });
      record.file = originalFile;

      // The Cloudflare URL remains in the lightweight session metadata as a
      // fallback, while IndexedDB carries the actual local File without the
      // small size limit of localStorage/sessionStorage.
      return writeMainPhotoTransfer(record).catch(function () {
        return null;
      }).then(function () {
        return metadata;
      });
    }

    function normalizeStoredFile(record) {
      if (!record || !record.file) return null;
      if (typeof File !== 'undefined' && record.file instanceof File) return record.file;
      try {
        return new File([record.file], record.fileName || 'photo.jpg', {
          type: record.fileType || record.file.type || 'image/jpeg',
          lastModified: record.lastModified || Date.now()
        });
      } catch (e) {
        return null;
      }
    }

    function fetchFallbackPhoto(record) {
      if (!record || !record.originalCloudUrl || !window.fetch) return Promise.resolve(null);
      return fetch(record.originalCloudUrl, { mode: 'cors', credentials: 'omit' }).then(function (res) {
        if (!res.ok) throw new Error('Could not download the saved photo.');
        return res.blob();
      }).then(function (blob) {
        return new File([blob], record.fileName || 'photo.jpg', {
          type: record.fileType || blob.type || 'image/jpeg',
          lastModified: record.lastModified || Date.now()
        });
      }).catch(function () { return null; });
    }

    /* Stage 7G: changing crystal shapes no longer opens the editor automatically.
       The original photo is restored, centered into the new shape using the prior
       crop focus when available, and saved as the new product preview in the
       background. The customer can then press Edit Photo to open the ordinary
       editor with ordinary Cropper dragging—no transfer-specific drag mode. */
    function clampNumber(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function canvasToPngBlob(canvas) {
      return new Promise(function (resolve, reject) {
        if (!canvas || typeof canvas.toBlob !== 'function') {
          reject(new Error('Could not prepare the transferred photo.'));
          return;
        }
        try {
          canvas.toBlob(function (blob) {
            if (blob) resolve(blob);
            else reject(new Error('Could not prepare the transferred photo.'));
          }, 'image/png', 0.92);
        } catch (err) {
          reject(err || new Error('Could not prepare the transferred photo.'));
        }
      });
    }

    function buildAutomaticTransferCrop(record) {
      return new Promise(function (resolve, reject) {
        if (!originalFile) {
          reject(new Error('The previous photo could not be restored.'));
          return;
        }

        var url = URL.createObjectURL(originalFile);
        var image = new Image();
        image.onload = function () {
          URL.revokeObjectURL(url);

          var naturalWidth = image.naturalWidth || image.width || 0;
          var naturalHeight = image.naturalHeight || image.height || 0;
          if (!naturalWidth || !naturalHeight) {
            reject(new Error('The previous photo has invalid dimensions.'));
            return;
          }

          var cfg = getShapeConfig(shape);
          var targetRatio = parseFloat(cfg.aspectRatio || SHAPE_CONFIG.default.aspectRatio || 1) || 1;
          var previousCrop = parseTransferredCropData(record && record.cropData ? record.cropData : '');
          var focusX = previousCrop ? previousCrop.x + (previousCrop.width / 2) : naturalWidth / 2;
          var focusY = previousCrop ? previousCrop.y + (previousCrop.height / 2) : naturalHeight / 2;
          focusX = clampNumber(focusX, 0, naturalWidth);
          focusY = clampNumber(focusY, 0, naturalHeight);

          var sourceWidth;
          var sourceHeight;

          if (previousCrop) {
            /* Preserve at least the area the customer had selected before. Expand
               rather than crop it further when the new shape has a new ratio. */
            sourceWidth = Math.max(1, previousCrop.width);
            sourceHeight = Math.max(1, previousCrop.height);
            if ((sourceWidth / sourceHeight) < targetRatio) {
              sourceWidth = sourceHeight * targetRatio;
            } else {
              sourceHeight = sourceWidth / targetRatio;
            }
          } else if ((naturalWidth / naturalHeight) > targetRatio) {
            sourceHeight = naturalHeight;
            sourceWidth = sourceHeight * targetRatio;
          } else {
            sourceWidth = naturalWidth;
            sourceHeight = sourceWidth / targetRatio;
          }

          /* If expanding the old crop exceeds the original photo, use the largest
             possible rectangle of the new ratio that fits inside the source. */
          if (sourceWidth > naturalWidth || sourceHeight > naturalHeight) {
            if ((naturalWidth / naturalHeight) > targetRatio) {
              sourceHeight = naturalHeight;
              sourceWidth = sourceHeight * targetRatio;
            } else {
              sourceWidth = naturalWidth;
              sourceHeight = sourceWidth / targetRatio;
            }
          }

          sourceWidth = Math.max(1, Math.min(naturalWidth, sourceWidth));
          sourceHeight = Math.max(1, Math.min(naturalHeight, sourceHeight));
          var sourceX = clampNumber(focusX - (sourceWidth / 2), 0, naturalWidth - sourceWidth);
          var sourceY = clampNumber(focusY - (sourceHeight / 2), 0, naturalHeight - sourceHeight);

          var outputWidth;
          var outputHeight;
          var longSide = 1800;
          if (targetRatio >= 1) {
            outputWidth = longSide;
            outputHeight = Math.max(1, Math.round(outputWidth / targetRatio));
          } else {
            outputHeight = longSide;
            outputWidth = Math.max(1, Math.round(outputHeight * targetRatio));
          }

          var canvas = document.createElement('canvas');
          canvas.width = outputWidth;
          canvas.height = outputHeight;
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, outputWidth, outputHeight);
          ctx.imageSmoothingEnabled = true;
          try { ctx.imageSmoothingQuality = 'high'; } catch (e) {}
          ctx.drawImage(
            image,
            sourceX, sourceY, sourceWidth, sourceHeight,
            0, 0, outputWidth, outputHeight
          );

          resolve({
            canvas: canvas,
            crop: {
              x: sourceX,
              y: sourceY,
              width: sourceWidth,
              height: sourceHeight,
              rotate: 0,
              scaleX: 1,
              scaleY: 1
            },
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight
          });
        };
        image.onerror = function () {
          URL.revokeObjectURL(url);
          reject(new Error('The previous photo could not be loaded.'));
        };
        image.src = url;
      });
    }

    function applyTransferredPhotoWithoutEditor(record) {
      destroyCropper();
      closeModal();
      transferredPlacement = null;
      useDirectTransferDrag = false;
      directDragState = null;
      rotationDeg = 0;
      zoomPercent = 100;
      previewCloudUrl = '';
      savedPreviewUrl = '';
      automaticTransferBaseCanvas = null;
      savedCompositeCanvas = null;

      setStatus('editing', isAccessoryEditor ? 'Applying your photo to the new accessory shape…' : 'Applying your photo to the new crystal shape…');

      return buildAutomaticTransferCrop(record).then(function (automaticCrop) {
        automaticTransferBaseCanvas = automaticCrop.canvas;
        if (cropDataInput) {
          cropDataInput.value = JSON.stringify({
            shape: shape,
            imageZone: getShapeConfig(shape).imageZone,
            crop: automaticCrop.crop,
            rotationDeg: 0,
            zoomPercent: 100,
            automaticShapeTransfer: true
          });
        }
        if (rotationInput) rotationInput.value = '0';
        if (zoomInput) zoomInput.value = '100';

        return buildCompositeCanvas(automaticCrop.canvas);
      }).then(function (finalCanvas) {
        savedCompositeCanvas = finalCanvas;
        var uploadCanvas = buildPreviewWithEngraving(finalCanvas);
        return Promise.all([canvasToPngBlob(finalCanvas), canvasToPngBlob(uploadCanvas)]).then(function (blobs) {
          if (savedPreviewUrl && /^blob:/.test(savedPreviewUrl)) {
            try { URL.revokeObjectURL(savedPreviewUrl); } catch (e) {}
          }
          savedPreviewUrl = URL.createObjectURL(blobs[0]);

          /* Show the local result immediately while the preview upload completes. */
          var mainImg = document.querySelector('.engoj_img_main');
          if (mainImg) {
            mainImg.src = savedPreviewUrl;
            lockProductGalleryPreview(savedPreviewUrl);
          }

          var blob = blobs[1];
          var editedFile = new File(
            [blob],
            sanitizeFilename(originalFile.name) + '-shape-transfer.png',
            { type: 'image/png', lastModified: Date.now() }
          );
          return uploadEditedAssets(editedFile).then(function () {
            setFiles(editedInput, [editedFile]);
            return editedFile;
          });
        });
      }).then(function () {
        if (photoName) photoName.textContent = originalFile.name + ' — applied to this shape';
        if (editAgain) editAgain.hidden = false;
        setStatus('saved', isAccessoryEditor ? 'Photo applied to this accessory shape. Use Edit Photo only if you want to adjust it.' : 'Photo applied to this crystal shape. Use Edit Photo only if you want to adjust it.');

        try {
          document.dispatchEvent(new CustomEvent('ll:image-editor:preview-saved', {
            bubbles: true,
            detail: {
              shape: shape,
              previewUrl: savedPreviewUrl,
              cloudPreviewUrl: previewCloudUrl,
              cloudOriginalUrl: originalCloudUrl,
              customizationId: customizationId,
              automaticShapeTransfer: true
            }
          }));
        } catch (e) {}

        /* Store the new automatic crop so another shape switch uses this page's
           current framing as its starting focus. */
        return prepareMainPhotoTransfer().catch(function () { return null; });
      });
    }

    function restoreMainPhotoTransfer(fallbackRecord) {
      if (isSecondary) return Promise.reject(new Error('This editor cannot receive the main crystal photo.'));

      return readMainPhotoTransfer().catch(function () { return null; }).then(function (storedRecord) {
        var record = storedRecord || fallbackRecord || null;
        if (storedRecord && fallbackRecord) {
          var storedTime = parseInt(storedRecord.savedAt || 0, 10) || 0;
          var fallbackTime = parseInt(fallbackRecord.savedAt || 0, 10) || 0;
          if (fallbackTime > storedTime) record = fallbackRecord;
        }
        if (!record) throw new Error('The previous photo could not be found.');

        var age = Date.now() - (parseInt(record.savedAt || 0, 10) || 0);
        if (age > MAIN_PHOTO_TRANSFER_MAX_AGE) {
          removeMainPhotoTransfer();
          throw new Error('The saved photo session expired. Please upload the photo again.');
        }

        var file = normalizeStoredFile(record);
        return (file ? Promise.resolve(file) : fetchFallbackPhoto(record)).then(function (restoredFile) {
          if (!restoredFile) throw new Error('The previous photo could not be restored.');

          originalFile = restoredFile;
          customizationId = makeCustomizationId();
          originalCloudUrl = record.originalCloudUrl || '';
          previewCloudUrl = '';
          saved = false;
          transferredPlacement = null;
          useDirectTransferDrag = false;
          directDragState = null;

          if (editedInput) editedInput.value = '';
          if (photoName) photoName.textContent = restoredFile.name + ' — applying to this shape';
          if (cropDataInput) cropDataInput.value = '';
          if (rotationInput) rotationInput.value = '0';
          if (zoomInput) zoomInput.value = '100';
          if (editAgain) editAgain.hidden = true;

          try {
            var dt = new DataTransfer();
            dt.items.add(restoredFile);
            originalInput.files = dt.files;
          } catch (e) {}

          setUploadPropertyInputs();
          return applyTransferredPhotoWithoutEditor(record).then(function () {
            return { restored: true, fileName: restoredFile.name, automatic: true };
          });
        });
      });
    }

    if (!isSecondary) {
      root.__llHasTransferableMainPhoto = function () { return !!originalFile; };
      root.__llGetMainPhotoTransferMetadata = getMainPhotoTransferMetadata;
      root.__llPrepareMainPhotoTransfer = prepareMainPhotoTransfer;
      root.__llRestoreMainPhotoTransfer = restoreMainPhotoTransfer;
    }

    if (modal.parentNode !== document.body) document.body.appendChild(modal);

    function qsEditor(selector) { return qs(modal, selector) || qs(root, selector); }
    function qsaEditor(selector) {
      var items = qsa(modal, selector).concat(qsa(root, selector));
      return items.filter(function (item, index) { return items.indexOf(item) === index; });
    }

    function syncEditorConfiguration() {
      shape = root.getAttribute('data-ll-editor-shape') || shape || 'default';
      backgroundAsset = root.getAttribute('data-ll-editor-background') || backgroundAsset || '';
      maskAsset = root.getAttribute('data-ll-editor-mask') || maskAsset || '';
      if (qs(root, '[data-ll-editor-shape-input]')) qs(root, '[data-ll-editor-shape-input]').value = shape;
      syncStageArt();
    }

    function findProductGallery() {
      return document.querySelector('.ll-configurator-media .detail-gallery') || document.querySelector('.detail-gallery');
    }


    function getConfiguratorRoot() {
      return root.closest('[data-ll-configurator]') || document.querySelector('[data-ll-configurator]') || form || document;
    }

    function getCurrentShapeKey() {
      if (isSecondary) return shape || 'default';
      var cfgRoot = getConfiguratorRoot();
      var selected = cfgRoot ? qs(cfgRoot, '.ll-cfg-shape.is-selected') : null;
      var key = selected ? (selected.getAttribute('data-ll-shape-key') || '') : '';
      if (!key && cfgRoot) key = cfgRoot.getAttribute('data-ll-current-shape-key') || '';
      return key || shape || 'default';
    }

    function getEngravingState() {
      if (isSecondary) return null;
      var cfgRoot = getConfiguratorRoot();
      if (!cfgRoot) return null;
      var toggle = qs(cfgRoot, '[data-ll-engraving-toggle]');
      if (!toggle || !toggle.checked) return null;
      var line1Input = qs(cfgRoot, '[data-ll-engraving-line1]');
      var line2Input = qs(cfgRoot, '[data-ll-engraving-line2]');
      var line1 = normalizeEngravingText(line1Input ? line1Input.value : '');
      var line2 = normalizeEngravingText(line2Input ? line2Input.value : '');
      var lines = [line1, line2].filter(Boolean);
      if (!lines.length) return null;
      return {
        shapeKey: getCurrentShapeKey(),
        lines: lines,
        length: (line1.length + line2.length)
      };
    }

    function getLiveEngravingTextStyle() {
      var textNode = document.querySelector('[data-ll-main-engraving-preview-text]');
      if (!textNode || !window.getComputedStyle) return null;

      try {
        var style = window.getComputedStyle(textNode);
        var fontSize = parseFloat(style.fontSize || '0') || 0;
        var lineHeight = parseFloat(style.lineHeight || '0') || 0;
        var fontWeight = parseInt(style.fontWeight || '700', 10) || 700;
        return {
          fontSize: fontSize,
          lineHeight: lineHeight || (fontSize * 1.12),
          fontWeight: fontWeight
        };
      } catch (e) {
        return null;
      }
    }

    function getCanvasScaleFromLivePreview(sourceCanvas) {
      var mainImg = document.querySelector('.engoj_img_main');
      if (!mainImg || !mainImg.getBoundingClientRect) return 1;

      try {
        var rect = mainImg.getBoundingClientRect();
        if (!rect || !rect.width) return 1;
        return sourceCanvas.width / rect.width;
      } catch (e) {
        return 1;
      }
    }

    function buildPreviewWithEngraving(sourceCanvas) {
      var engraving = getEngravingState();
      if (!sourceCanvas || !engraving) return sourceCanvas;

      var canvas = document.createElement('canvas');
      canvas.width = sourceCanvas.width;
      canvas.height = sourceCanvas.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(sourceCanvas, 0, 0);

      var pos = getEngravingPosition(engraving.shapeKey);
      var liveStyle = getLiveEngravingTextStyle();
      var scale = getCanvasScaleFromLivePreview(sourceCanvas);
      if (!scale || !isFinite(scale) || scale <= 0) scale = 1;

      var lengthPenalty = Math.max(0, Math.min(4, Math.floor((engraving.length - 18) / 10)));
      var cssFontSize = liveStyle && liveStyle.fontSize ? liveStyle.fontSize : Math.max(12, (pos.size || 15) - lengthPenalty);
      var cssLineHeight = liveStyle && liveStyle.lineHeight ? liveStyle.lineHeight : (cssFontSize * (pos.lineHeight || 1.12));
      var fontSize = cssFontSize * scale;
      var lineHeight = cssLineHeight * scale;

      var cssInset = window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 10 : 16;
      var inset = cssInset * scale;
      var areaWidth = canvas.width - (inset * 2);
      var areaHeight = canvas.height - (inset * 2);
      var x = inset + areaWidth * ((pos.x || 50) / 100);
      var y = inset + areaHeight * ((pos.y || 85) / 100);
      var maxWidth = areaWidth * ((pos.w || 42) / 100);
      var totalHeight = fontSize + ((engraving.lines.length - 1) * lineHeight);
      var startY = y - (totalHeight / 2) + (fontSize / 2);
      var weight = liveStyle && liveStyle.fontWeight ? liveStyle.fontWeight : (/^(diamond|heart|paw)$/.test(engraving.shapeKey) ? 800 : 700);

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(((pos.rotate || 0) * Math.PI) / 180);
      ctx.translate(-x, -y);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = 'rgba(255,255,255,0.92)';
      ctx.shadowColor = 'rgba(10,46,92,0.78)';
      ctx.shadowBlur = Math.max(3 * scale, Math.round(fontSize * 0.45));
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 1 * scale;
      ctx.font = weight + ' ' + fontSize + 'px Arial, Helvetica, sans-serif';

      engraving.lines.forEach(function (line, index) {
        var lineY = startY + (index * lineHeight);
        ctx.fillText(line, x, lineY, maxWidth);
      });

      ctx.shadowColor = 'rgba(0,0,0,0.65)';
      ctx.shadowBlur = 0;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 1 * scale;
      engraving.lines.forEach(function (line, index) {
        var lineY = startY + (index * lineHeight);
        ctx.fillText(line, x, lineY, maxWidth);
      });

      ctx.restore();
      return canvas;
    }

    function lockProductGalleryPreview(previewUrl) {
      var mainImg = document.querySelector('.engoj_img_main');
      var gallery = mainImg ? mainImg.closest('.detail-gallery') : findProductGallery();
      if (!gallery || !mainImg || !previewUrl) return;

      gallery.classList.add('ll-has-upload-preview', 'll-preview-locked');
      gallery.setAttribute('data-ll-preview-locked', 'true');
      gallery.setAttribute('data-ll-preview-url', previewUrl);
      mainImg.classList.add('ll-upload-preview-active');

      qsa(gallery, '.gallery-control a, .gallery-control button, .gallery-control li, .gallery-control img').forEach(function (item) {
        item.setAttribute('aria-disabled', 'true');
        if (item.matches && item.matches('a, button')) item.setAttribute('tabindex', '-1');
      });

      if (!gallery.__llPreviewObserver) {
        gallery.__llPreviewObserver = new MutationObserver(function () {
          if (!gallery.classList.contains('ll-preview-locked')) return;
          var lockedUrl = gallery.getAttribute('data-ll-preview-url') || '';
          if (lockedUrl && mainImg.getAttribute('src') !== lockedUrl) {
            mainImg.setAttribute('src', lockedUrl);
          }
        });
        gallery.__llPreviewObserver.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
      }
    }

    function syncStageArt() {
      var bg = qsEditor('[data-ll-editor-stage-background]');
      var overlay = qsEditor('[data-ll-editor-stage-overlay]');
      if (bg && backgroundAsset) bg.src = backgroundAsset;
      if (overlay && maskAsset) overlay.src = maskAsset;
    }

    function resizeStage() {
      var stage = qsEditor('[data-ll-editor-stage]');
      var dialog = qsEditor('.ll-editor-modal__dialog');
      if (!stage || !dialog || modal.hidden) return;

      var overlay = qsEditor('[data-ll-editor-stage-overlay]');
      var overlaySize = getNaturalSize(overlay);
      var ratio = overlaySize ? (overlaySize.width / overlaySize.height) : 1;
      if (!ratio || !isFinite(ratio) || ratio <= 0) ratio = 1;

      var header = qsEditor('.ll-editor-modal__header');
      var help = qsEditor('.ll-editor-modal__help');
      var controls = qsEditor('.ll-editor-controls');
      var footer = qsEditor('.ll-editor-modal__footer');
      var usedHeight =
        (header ? header.offsetHeight : 0) +
        (help ? help.offsetHeight : 0) +
        (controls ? controls.offsetHeight : 0) +
        (footer ? footer.offsetHeight : 0) +
        58;

      var maxHeight = Math.max(280, window.innerHeight - usedHeight);
      var maxWidth = Math.max(280, dialog.clientWidth - (window.innerWidth <= 767 ? 20 : 36));
      var width = maxWidth;
      var height = width / ratio;

      if (height > maxHeight) {
        height = maxHeight;
        width = height * ratio;
      }

      stage.style.width = Math.floor(width) + 'px';
      stage.style.height = Math.floor(height) + 'px';
      stage.style.aspectRatio = String(ratio);
    }

    /* Stage 7D: Cropper's internal crop was correct, but its DOM image could
       remain rendered at the tiny pre-layout size after a cross-page shape
       transfer. Saving used the correct internal crop, creating a mismatch
       between the editor and the resulting product preview.

       Render a lightweight mirror from getCroppedCanvas() directly into the
       mask's real image zone. The same crop source is used by Save Photo, so
       what the customer sees here now matches what will be generated. Cropper
       remains fully interactive underneath this mirror for drag/zoom/rotate. */
    function ensureLivePreviewCanvas() {
      var stage = qsEditor('[data-ll-editor-stage]');
      if (!stage) return null;
      if (!livePreviewCanvas || livePreviewCanvas.parentNode !== stage) {
        livePreviewCanvas = document.createElement('canvas');
        livePreviewCanvas.className = 'll-editor-live-preview';
        livePreviewCanvas.setAttribute('aria-hidden', 'true');
        var overlay = qs(stage, '[data-ll-editor-stage-overlay]');
        if (overlay) stage.insertBefore(livePreviewCanvas, overlay);
        else stage.appendChild(livePreviewCanvas);
      }
      stage.classList.add('ll-editor-stage--output-mirror');
      return livePreviewCanvas;
    }

    function clearLivePreviewMirror() {
      if (livePreviewFrame) {
        window.cancelAnimationFrame(livePreviewFrame);
        livePreviewFrame = 0;
      }
      if (livePreviewTimer) {
        clearTimeout(livePreviewTimer);
        livePreviewTimer = 0;
      }
      var stage = qsEditor('[data-ll-editor-stage]');
      if (stage) stage.classList.remove('ll-editor-stage--output-mirror');
      if (livePreviewCanvas) {
        var ctx = livePreviewCanvas.getContext('2d');
        if (ctx) ctx.clearRect(0, 0, livePreviewCanvas.width || 1, livePreviewCanvas.height || 1);
        livePreviewCanvas.style.opacity = '0';
      }
    }

    function renderLivePreviewMirror() {
      if (!cropper || modal.hidden) return false;
      var stage = qsEditor('[data-ll-editor-stage]');
      var target = ensureLivePreviewCanvas();
      if (!stage || !target || stage.clientWidth < 20 || stage.clientHeight < 20) return false;

      var cfg = getShapeConfig(shape);
      var zone = cfg.imageZone || SHAPE_CONFIG.default.imageZone;
      var displayWidth = Math.max(2, stage.clientWidth * zone.w);
      var displayHeight = Math.max(2, stage.clientHeight * zone.h);

      /* Stage 7E: the Stage 7D mirror was rebuilding a large, grayscale canvas
         during every drag event. That work could fall behind the pointer and
         then jump to the newest position, which felt like an over-sensitive
         drag even though Cropper's underlying coordinates were correct.

         Use a deliberately lightweight interaction canvas and let CSS handle
         grayscale. When the pointer is released, render one sharper idle frame. */
      var maxPreviewSide = livePreviewInteracting ? 460 : 900;
      var previewScale = Math.min(1, maxPreviewSide / Math.max(displayWidth, displayHeight));
      var outputWidth = Math.max(2, Math.round(displayWidth * previewScale));
      var outputHeight = Math.max(2, Math.round(displayHeight * previewScale));
      var sourceCanvas = null;

      try {
        sourceCanvas = cropper.getCroppedCanvas({
          width: outputWidth,
          height: outputHeight,
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high',
          fillColor: '#ffffff'
        });
      } catch (e) {
        sourceCanvas = null;
      }
      if (!sourceCanvas || !sourceCanvas.width || !sourceCanvas.height) return false;

      target.width = sourceCanvas.width;
      target.height = sourceCanvas.height;
      target.style.left = (zone.x * 100) + '%';
      target.style.top = (zone.y * 100) + '%';
      target.style.width = (zone.w * 100) + '%';
      target.style.height = (zone.h * 100) + '%';
      var ctx = target.getContext('2d');
      ctx.clearRect(0, 0, target.width, target.height);
      ctx.drawImage(sourceCanvas, 0, 0, target.width, target.height);
      target.style.opacity = '1';
      return true;
    }

    function scheduleLivePreviewMirror(force) {
      if (!cropper || modal.hidden) return;
      if (livePreviewFrame) return;
      if (livePreviewTimer) {
        clearTimeout(livePreviewTimer);
        livePreviewTimer = 0;
      }

      /* One render at most per animation frame keeps the mirror synchronized
         with the pointer without queuing delayed, jumpy updates. */
      livePreviewFrame = window.requestAnimationFrame(function () {
        livePreviewFrame = 0;
        livePreviewLastRender = Date.now();
        renderLivePreviewMirror();
      });
    }

    syncStageArt();
    loadImage(maskAsset).then(function () {
      resizeStage();
      setTimeout(function () { resizeStage(); if (cropper) lockCropBox(); }, 80);
    }).catch(function () {});

    function emitStatus(value, text) {
      try {
        root.dispatchEvent(new CustomEvent('ll:image-editor:status', {
          bubbles: true,
          detail: {
            status: value || '',
            text: text || '',
            saved: value === 'saved',
            fileName: originalFile ? originalFile.name : '',
            previewUrl: savedPreviewUrl || '',
            cloudPreviewUrl: previewCloudUrl || '',
            cloudOriginalUrl: originalCloudUrl || '',
            customizationId: customizationId || '',
            shape: shape || 'default',
            secondary: isSecondary
          }
        }));
      } catch (e) {}
    }

    function setStatus(value, text) {
      saved = value === 'saved';
      if (statusInput) statusInput.value = value || '';
      if (statusText && text) statusText.textContent = text;
      if (inlineError) showText(inlineError, '');
      root.classList.toggle('is-saved', saved);
      emitStatus(value, text);
    }

    function setUploadPropertyInputs() {
      if (customizationIdInput) customizationIdInput.value = customizationId || '';
      if (originalUrlInput) originalUrlInput.value = originalCloudUrl || '';
      if (previewUrlInput) previewUrlInput.value = previewCloudUrl || '';
      if (previewUrlPrivateInput) previewUrlPrivateInput.value = previewCloudUrl || '';
      if (previewUrlAppInput) previewUrlAppInput.value = previewCloudUrl || '';
    }

    function clearCloudUploadState() {
      customizationId = makeCustomizationId();
      originalCloudUrl = '';
      previewCloudUrl = '';
      setUploadPropertyInputs();
    }

    function resetEditorState(message) {
      destroyCropper();
      closeModal();
      originalFile = null;
      savedPreviewUrl = '';
      automaticTransferBaseCanvas = null;
      savedCompositeCanvas = null;
      committedCropData = null;
      useDirectTransferDrag = false;
      directDragState = null;
      rotationDeg = 0;
      zoomPercent = 100;
      if (originalInput) originalInput.value = '';
      if (editedInput) editedInput.value = '';
      if (photoName) photoName.textContent = '';
      if (editAgain) editAgain.hidden = true;
      if (cropDataInput) cropDataInput.value = '';
      if (rotationInput) rotationInput.value = '0';
      if (zoomInput) zoomInput.value = '100';
      clearCloudUploadState();
      setStatus('', message || 'Choose a photo to start designing.');
    }

    function uploadEditedAssets(editedFile) {
      setUploadPropertyInputs();
      var originalPromise = originalCloudUrl
        ? Promise.resolve({ url: originalCloudUrl, customization_id: customizationId })
        : uploadToCloudflare(cloudflareUploadEndpoint, originalFile, originalFile.name, 'original', customizationId);

      return originalPromise.then(function (originalResult) {
        originalCloudUrl = originalResult.url || originalCloudUrl;
        if (originalResult.customization_id) customizationId = originalResult.customization_id;
        setUploadPropertyInputs();
        return uploadToCloudflare(cloudflareUploadEndpoint, editedFile, editedFile.name, 'preview', customizationId);
      }).then(function (previewResult) {
        previewCloudUrl = previewResult.url || previewCloudUrl;
        if (previewResult.customization_id) customizationId = previewResult.customization_id;
        setUploadPropertyInputs();
        return { originalUrl: originalCloudUrl, previewUrl: previewCloudUrl, customizationId: customizationId };
      });
    }

    function positionMaskGuide() {
      if (!cropper || !maskGuide) return;
      try {
        var stage = qs(modal, '[data-ll-editor-stage]');
        var container = stage ? qs(stage, '.cropper-container') : null;
        if (!stage || !container) return;
        var cropBoxData = cropper.getCropBoxData();
        var stageRect = stage.getBoundingClientRect();
        var containerRect = container.getBoundingClientRect();
        maskGuide.style.left = (containerRect.left - stageRect.left + cropBoxData.left) + 'px';
        maskGuide.style.top = (containerRect.top - stageRect.top + cropBoxData.top) + 'px';
        maskGuide.style.width = cropBoxData.width + 'px';
        maskGuide.style.height = cropBoxData.height + 'px';
        maskGuide.classList.add('is-active');
      } catch (e) {}
    }

    function lockCropBox() {
      if (!cropper || typeof cropper.setCropBoxData !== 'function') return;
      try {
        var containerData = cropper.getContainerData();
        var cfg = getShapeConfig(shape);
        var zone = cfg.imageZone || SHAPE_CONFIG.default.imageZone;
        var ratio = cfg.aspectRatio || SHAPE_CONFIG.default.aspectRatio;
        var cropWidth = containerData.width * zone.w;
        var cropHeight = cropWidth / ratio;

        if (cropHeight > containerData.height * zone.h) {
          cropHeight = containerData.height * zone.h;
          cropWidth = cropHeight * ratio;
        }

        cropWidth = Math.min(cropWidth, containerData.width * 0.94);
        cropHeight = Math.min(cropHeight, containerData.height * 0.94);
        var left = containerData.width * zone.x + ((containerData.width * zone.w) - cropWidth) / 2;
        var top = containerData.height * zone.y + ((containerData.height * zone.h) - cropHeight) / 2;
        left = Math.max(0, Math.min(containerData.width - cropWidth, left));
        top = Math.max(0, Math.min(containerData.height - cropHeight, top));
        cropper.setCropBoxData({ width: cropWidth, height: cropHeight, left: left, top: top });
        positionMaskGuide();
        scheduleLivePreviewMirror(true);
      } catch (e) {}
    }

    function destroyCropper() {
      /* Invalidate any image-load/requestAnimationFrame work from an older boot. */
      cropperBootToken += 1;
      if (cropper && typeof cropper.destroy === 'function') cropper.destroy();
      cropper = null;
      livePreviewInteracting = false;
      directDragState = null;
      var dragStage = qsEditor('[data-ll-editor-stage]');
      if (dragStage) dragStage.classList.remove('ll-editor-stage--direct-drag', 'll-editor-stage--direct-dragging');
      clearLivePreviewMirror();
      if (maskGuide) maskGuide.classList.remove('is-active');
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = '';
    }

    function cloneCropData(data) {
      if (!data || typeof data !== 'object') return null;
      var copy = {};
      ['x', 'y', 'width', 'height', 'rotate', 'scaleX', 'scaleY'].forEach(function (key) {
        if (data[key] !== undefined && data[key] !== null && isFinite(Number(data[key]))) {
          copy[key] = Number(data[key]);
        }
      });
      if (!isFinite(copy.x) || !isFinite(copy.y) || !isFinite(copy.width) || !isFinite(copy.height) || copy.width <= 0 || copy.height <= 0) return null;
      return copy;
    }

    function commitCurrentCropFrame() {
      if (!cropper || typeof cropper.getData !== 'function') return null;
      try {
        var data = cloneCropData(cropper.getData(true));
        if (!data) return null;
        committedCropData = data;
        if (cropDataInput) {
          cropDataInput.value = JSON.stringify({
            shape: shape,
            imageZone: getShapeConfig(shape).imageZone,
            crop: data,
            rotationDeg: rotationDeg || 0,
            zoomPercent: zoomPercent || 100
          });
        }
        return data;
      } catch (e) {
        return null;
      }
    }

    function restoreCommittedCropFrame() {
      if (!cropper || !committedCropData || typeof cropper.setData !== 'function') return false;
      try {
        cropper.setData(committedCropData);
        positionMaskGuide();
        return true;
      } catch (e) {
        return false;
      }
    }

    function openModal() {
      syncEditorConfiguration();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ll-image-editor-open');
      document.body.classList.add('ll-image-editor-open');
      lastEditorViewportWidth = document.documentElement.clientWidth || window.innerWidth || 0;
      resizeStage();
      ensureLivePreviewCanvas();
      setTimeout(function () { resizeStage(); if (cropper) { lockCropBox(); scheduleLivePreviewMirror(true); } }, 80);
      setTimeout(function () { resizeStage(); if (cropper) { lockCropBox(); scheduleLivePreviewMirror(true); } }, 220);
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ll-image-editor-open');
      document.body.classList.remove('ll-image-editor-open');
    }

    function getDirectDragBounds(canvasData) {
      if (!cropper || !canvasData) return null;
      try {
        var cropBox = cropper.getCropBoxData();
        if (!cropBox || cropBox.width < 1 || cropBox.height < 1) return null;
        return {
          minLeft: cropBox.left + cropBox.width - canvasData.width,
          maxLeft: cropBox.left,
          minTop: cropBox.top + cropBox.height - canvasData.height,
          maxTop: cropBox.top
        };
      } catch (e) {
        return null;
      }
    }

    function beginDirectTransferDrag(event) {
      if (!useDirectTransferDrag || !cropper || modal.hidden) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      var stage = qsEditor('[data-ll-editor-stage]');
      if (!stage) return;

      var canvasData;
      try { canvasData = cropper.getCanvasData(); } catch (e) { canvasData = null; }
      if (!canvasData || !isFinite(canvasData.left) || !isFinite(canvasData.top) ||
          !isFinite(canvasData.width) || !isFinite(canvasData.height)) return;

      directDragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        left: canvasData.left,
        top: canvasData.top,
        width: canvasData.width,
        height: canvasData.height,
        bounds: getDirectDragBounds(canvasData)
      };
      livePreviewInteracting = true;
      stage.classList.add('ll-editor-stage--direct-dragging');
      try { stage.setPointerCapture(event.pointerId); } catch (e) {}
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    function moveDirectTransferDrag(event) {
      if (!directDragState || !cropper || event.pointerId !== directDragState.pointerId) return;

      /* Pointer client coordinates and Cropper canvas coordinates are both CSS
         pixels. Applying the delta directly guarantees one screen pixel of
         pointer movement equals one screen pixel of image movement. */
      var nextLeft = directDragState.left + (event.clientX - directDragState.startX);
      var nextTop = directDragState.top + (event.clientY - directDragState.startY);
      var bounds = directDragState.bounds;
      if (bounds) {
        nextLeft = Math.max(bounds.minLeft, Math.min(bounds.maxLeft, nextLeft));
        nextTop = Math.max(bounds.minTop, Math.min(bounds.maxTop, nextTop));
      }

      try {
        cropper.setCanvasData({
          left: nextLeft,
          top: nextTop,
          width: directDragState.width,
          height: directDragState.height
        });
        positionMaskGuide();
        scheduleLivePreviewMirror(false);
      } catch (e) {}

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    function endDirectTransferDrag(event) {
      if (!directDragState || event.pointerId !== directDragState.pointerId) return;
      var stage = qsEditor('[data-ll-editor-stage]');
      if (stage) {
        stage.classList.remove('ll-editor-stage--direct-dragging');
        try { stage.releasePointerCapture(event.pointerId); } catch (e) {}
      }
      directDragState = null;
      livePreviewInteracting = false;
      commitCurrentCropFrame();
      scheduleLivePreviewMirror(true);
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    var directDragStage = qsEditor('[data-ll-editor-stage]');
    if (directDragStage && window.PointerEvent) {
      directDragStage.addEventListener('pointerdown', beginDirectTransferDrag, true);
      directDragStage.addEventListener('pointermove', moveDirectTransferDrag, true);
      directDragStage.addEventListener('pointerup', endDirectTransferDrag, true);
      directDragStage.addEventListener('pointercancel', endDirectTransferDrag, true);
    }

    function applyInitialZoomOut() {
      if (!cropper || typeof cropper.getImageData !== 'function' || typeof cropper.zoomTo !== 'function') return;
      try {
        var imageData = cropper.getImageData();
        if (!imageData || !imageData.naturalWidth) return;
        var currentRatio = imageData.width / imageData.naturalWidth;
        if (!currentRatio || !isFinite(currentRatio)) return;
        cropper.zoomTo(currentRatio * 0.8);
        positionMaskGuide();
      } catch (e) {}
    }

    function parseTransferredCropData(raw) {
      if (!raw) return null;
      var parsed = raw;
      if (typeof raw === 'string') {
        try { parsed = JSON.parse(raw); } catch (e) { return null; }
      }
      if (!parsed || typeof parsed !== 'object') return null;
      var crop = parsed.crop && typeof parsed.crop === 'object' ? parsed.crop : parsed;
      var x = parseFloat(crop.x);
      var y = parseFloat(crop.y);
      var width = parseFloat(crop.width);
      var height = parseFloat(crop.height);
      if (![x, y, width, height].every(function (value) { return isFinite(value); })) return null;
      if (width <= 0 || height <= 0) return null;
      return { x: x, y: y, width: width, height: height };
    }

    /* Stage 7B: transferred photos must cover the new shape crop immediately.
       Cropper can report a zero/temporary crop box during its first ready frame.
       The old code consumed the transfer on that failed first attempt and then ran
       the normal zoom-out routine, which produced the tiny centered thumbnail.
       We now keep the transfer pending until layout is stable and set the canvas
       dimensions directly so the photo visibly covers the fixed engraving zone. */
    function positionPhotoOverCropBox(placement) {
      if (!cropper || typeof cropper.getCropBoxData !== 'function' ||
          typeof cropper.getImageData !== 'function' || typeof cropper.setCanvasData !== 'function') return false;

      try {
        var cropBox = cropper.getCropBoxData();
        var imageData = cropper.getImageData();
        if (!cropBox || cropBox.width < 20 || cropBox.height < 20 || !imageData ||
            !imageData.naturalWidth || !imageData.naturalHeight) return false;

        var previousCrop = placement ? parseTransferredCropData(placement.cropData) : null;
        var naturalWidth = imageData.naturalWidth;
        var naturalHeight = imageData.naturalHeight;
        var focusX = naturalWidth / 2;
        var focusY = naturalHeight / 2;

        /* Always cover the complete fixed crop box, with a small safety margin. */
        var coverRatio = Math.max(
          cropBox.width / naturalWidth,
          cropBox.height / naturalHeight
        ) * 1.06;
        var targetRatio = coverRatio;

        /* Preserve the previous crop's center and approximate framing whenever
           possible, while never allowing the new shape to expose empty space. */
        if (previousCrop) {
          focusX = previousCrop.x + (previousCrop.width / 2);
          focusY = previousCrop.y + (previousCrop.height / 2);
          focusX = Math.max(0, Math.min(naturalWidth, focusX));
          focusY = Math.max(0, Math.min(naturalHeight, focusY));
          targetRatio = Math.max(
            coverRatio,
            cropBox.width / previousCrop.width,
            cropBox.height / previousCrop.height
          );
        }

        if (!targetRatio || !isFinite(targetRatio) || targetRatio <= 0) return false;
        targetRatio = Math.max(0.01, Math.min(50, targetRatio));

        var canvasWidth = naturalWidth * targetRatio;
        var canvasHeight = naturalHeight * targetRatio;
        var cropCenterX = cropBox.left + (cropBox.width / 2);
        var cropCenterY = cropBox.top + (cropBox.height / 2);
        var left = cropCenterX - (focusX * targetRatio);
        var top = cropCenterY - (focusY * targetRatio);

        /* Clamp the canvas so the crop area is fully covered on every side. */
        var minLeft = cropBox.left + cropBox.width - canvasWidth;
        var maxLeft = cropBox.left;
        var minTop = cropBox.top + cropBox.height - canvasHeight;
        var maxTop = cropBox.top;
        left = Math.max(minLeft, Math.min(maxLeft, left));
        top = Math.max(minTop, Math.min(maxTop, top));

        cropper.setCanvasData({
          left: left,
          top: top,
          width: canvasWidth,
          height: canvasHeight
        });

        positionMaskGuide();
        commitCurrentCropFrame();
        scheduleLivePreviewMirror(true);
        return true;
      } catch (e) {
        return false;
      }
    }

    function applyTransferredPhotoPlacement() {
      if (!transferredPlacement) return false;
      if (!positionPhotoOverCropBox(transferredPlacement)) return false;
      transferredPlacement = null;
      return true;
    }

    function settleTransferredPhotoPlacement(attempt) {
      attempt = attempt || 0;
      if (!transferredPlacement) return true;

      resizeStage();
      lockCropBox();
      if (applyTransferredPhotoPlacement()) {
        lockCropBox();
        scheduleLivePreviewMirror(true);
        return true;
      }

      /* Wait through several layout frames instead of discarding the transfer. */
      if (attempt < 8) {
        setTimeout(function () { settleTransferredPhotoPlacement(attempt + 1); }, 70 + (attempt * 45));
        return false;
      }

      /* Last-resort cover fit: still never show the photo as a tiny thumbnail. */
      if (positionPhotoOverCropBox(null)) {
        transferredPlacement = null;
        lockCropBox();
        scheduleLivePreviewMirror(true);
        return true;
      }
      return false;
    }

    function bootCropper() {
      syncEditorConfiguration();
      destroyCropper();
      if (!originalFile) return;

      var bootToken = ++cropperBootToken;
      objectUrl = URL.createObjectURL(originalFile);
      editorImage.onload = null;
      editorImage.onerror = null;
      editorImage.removeAttribute('src');
      rotationDeg = 0;
      zoomPercent = 100;
      showText(modalError, '');
      syncStageArt();

      /* Stage 7C: make the modal and its final-size stage visible BEFORE the
         object URL is assigned. Restored IndexedDB blobs can load immediately;
         previously Cropper was sometimes constructed while the modal was still
         hidden, so it measured its minimum 200x100 container and left the photo
         looking like a tiny thumbnail after the full editor expanded. */
      openModal();
      resizeStage();

      editorImage.onload = function () {
        if (bootToken !== cropperBootToken) return;
        resizeStage();
        if (typeof Cropper === 'undefined') {
          showText(modalError, 'The editor library did not load. Please refresh and try again.');
          return;
        }
        cropper = new Cropper(editorImage, {
          viewMode: 0,
          dragMode: useDirectTransferDrag ? 'none' : 'move',
          autoCrop: true,
          autoCropArea: 0.86,
          responsive: true,
          restore: false,
          background: false,
          guides: false,
          center: false,
          movable: true,
          zoomable: true,
          rotatable: true,
          scalable: false,
          cropBoxMovable: false,
          cropBoxResizable: false,
          toggleDragModeOnDblclick: false,
          aspectRatio: getShapeConfig(shape).aspectRatio || SHAPE_CONFIG.default.aspectRatio,
          ready: function () {
            if (bootToken !== cropperBootToken) return;
            resizeStage();
            ensureLivePreviewCanvas();
            var activeStage = qsEditor('[data-ll-editor-stage]');
            if (activeStage) activeStage.classList.toggle('ll-editor-stage--direct-drag', useDirectTransferDrag);
            lockCropBox();
            scheduleLivePreviewMirror(true);
            if (transferredPlacement) {
              /* The stage is now visible before Cropper starts. Keep the retry
                 pass as a safeguard for fonts/mobile viewport settling. */
              setTimeout(function () {
                if (bootToken === cropperBootToken) settleTransferredPhotoPlacement(0);
              }, 90);
              setTimeout(function () {
                if (bootToken === cropperBootToken && transferredPlacement) settleTransferredPhotoPlacement(0);
              }, 320);
            } else {
              setTimeout(function () {
                if (bootToken !== cropperBootToken) return;
                applyInitialZoomOut();
                lockCropBox();
                setTimeout(function () { if (bootToken === cropperBootToken) commitCurrentCropFrame(); }, 40);
              }, 80);
            }
            setTimeout(function () {
              if (bootToken === cropperBootToken) lockCropBox();
            }, 220);
          },
          cropstart: function () {
            if (bootToken !== cropperBootToken) return;
            livePreviewInteracting = true;
            scheduleLivePreviewMirror(true);
          },
          cropend: function () {
            if (bootToken !== cropperBootToken) return;
            livePreviewInteracting = false;
            commitCurrentCropFrame();
            scheduleLivePreviewMirror(true);
          },
          zoom: function () {
            if (bootToken !== cropperBootToken) return;
            /* Zoom events are direct customer edits, so commit the framing after
               Cropper has applied the zoom for this frame. */
            setTimeout(function () { if (bootToken === cropperBootToken) commitCurrentCropFrame(); }, 0);
            scheduleLivePreviewMirror(false);
          },
          crop: function () {
            if (bootToken !== cropperBootToken) return;
            try {
              var data = cropper.getData(true);
              var imageData = cropper.getImageData();
              if (imageData && imageData.naturalWidth) zoomPercent = Math.round((imageData.width / imageData.naturalWidth) * 100);
              if (zoomInput) zoomInput.value = String(zoomPercent || 100);
              if (rotationInput) rotationInput.value = String(rotationDeg || 0);
              /* Keep the transfer/order crop metadata tied to the last
                 customer-controlled frame. Layout-only crop events must not
                 silently replace it on mobile. */
              if (cropDataInput && (livePreviewInteracting || !committedCropData)) {
                cropDataInput.value = JSON.stringify({ shape: shape, imageZone: getShapeConfig(shape).imageZone, crop: data, rotationDeg: rotationDeg || 0, zoomPercent: zoomPercent || 100 });
              }
              positionMaskGuide();
              scheduleLivePreviewMirror(false);
            } catch (e) {}
          }
        });
      };
      editorImage.onerror = function () {
        if (bootToken !== cropperBootToken) return;
        showText(modalError, 'Could not load this image. Please try another file.');
      };

      /* Two animation frames guarantee that display:none has been removed and
         the browser has committed the real stage dimensions before Cropper
         reads them, even when the restored Blob resolves synchronously. */
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (bootToken !== cropperBootToken) return;
          resizeStage();
          editorImage.src = objectUrl;
        });
      });
    }

    function buildGrayscaleCanvas(source, targetWidth, targetHeight) {
      if (!source) return source;

      var sourceWidth = source.width || source.naturalWidth || 0;
      var sourceHeight = source.height || source.naturalHeight || 0;
      if (!sourceWidth || !sourceHeight) return source;

      /* Stage 7N mobile export fix: the old path duplicated the full Cropper
         output (up to 2200x3000) just to grayscale it, which can exhaust the
         canvas memory budget on iOS/embedded Shopify mobile previews. Build the
         grayscale working canvas at the final crystal image-zone size instead. */
      var width = Math.max(1, Math.round(targetWidth || sourceWidth));
      var height = Math.max(1, Math.round(targetHeight || sourceHeight));
      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      if (!ctx) return source;
      ctx.imageSmoothingEnabled = true;
      try { ctx.imageSmoothingQuality = 'high'; } catch (e) {}
      ctx.drawImage(source, 0, 0, width, height);

      try {
        var imageData = ctx.getImageData(0, 0, width, height);
        var data = imageData.data;
        for (var i = 0; i < data.length; i += 4) {
          var gray = Math.round((data[i] * 0.299) + (data[i + 1] * 0.587) + (data[i + 2] * 0.114));
          data[i] = gray;
          data[i + 1] = gray;
          data[i + 2] = gray;
        }
        ctx.putImageData(imageData, 0, 0);
      } catch (e) {
        /* If a browser cannot read pixels, keep the scaled image rather than
           failing the entire save operation. */
      }

      return canvas;
    }

    function buildCompositeCanvas(croppedCanvas) {
      return Promise.all([
        loadImage(backgroundAsset).catch(function () { return null; }),
        loadImage(maskAsset).catch(function () { return null; })
      ]).then(function (images) {
        var bg = images[0];
        var mask = images[1];
        if (!bg && !mask) return croppedCanvas;

        var outputWidth = (mask && (mask.naturalWidth || mask.width)) || (bg && (bg.naturalWidth || bg.width)) || croppedCanvas.width;
        var outputHeight = (mask && (mask.naturalHeight || mask.height)) || (bg && (bg.naturalHeight || bg.height)) || croppedCanvas.height;
        var canvas = document.createElement('canvas');
        canvas.width = outputWidth;
        canvas.height = outputHeight;
        var ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Canvas is unavailable.');
        var cfg = getShapeConfig(shape);
        var zone = cfg.imageZone || SHAPE_CONFIG.default.imageZone;
        var zx = Math.round(zone.x * outputWidth);
        var zy = Math.round(zone.y * outputHeight);
        var zw = Math.round(zone.w * outputWidth);
        var zh = Math.round(zone.h * outputHeight);

        if (bg) ctx.drawImage(bg, 0, 0, outputWidth, outputHeight);
        else {
          ctx.fillStyle = '#0a3b7a';
          ctx.fillRect(0, 0, outputWidth, outputHeight);
        }

        var grayscalePhoto = buildGrayscaleCanvas(croppedCanvas, zw, zh);
        ctx.drawImage(grayscalePhoto, zx, zy, zw, zh);
        if (mask) ctx.drawImage(mask, 0, 0, outputWidth, outputHeight);
        return canvas;
      });
    }

    /* Stage 7AB: one canonical crop geometry.
       Previously the live editor mirror and Save Photo each asked Cropper to
       generate a different-sized canvas, and Stage 7AA additionally restored a
       separately committed crop before export. On touch devices that committed
       frame can lag behind the last drag/pinch, so Save can export a slightly
       older zoom/position than the one still visible in the editor.

       The final product only has a finite photo zone inside the crystal mask.
       Capture Cropper directly at that exact zone resolution and use that canvas
       as the source of truth for the saved composite. */
    function getFinalPhotoZoneSize() {
      var cfg = getShapeConfig(shape);
      var zone = cfg.imageZone || SHAPE_CONFIG.default.imageZone;
      var overlay = qsEditor('[data-ll-editor-stage-overlay]');
      var overlaySize = getNaturalSize(overlay);
      var outputWidth = overlaySize && overlaySize.width ? overlaySize.width : 1254;
      var outputHeight = overlaySize && overlaySize.height ? overlaySize.height : 1254;
      return {
        width: Math.max(2, Math.round(zone.w * outputWidth)),
        height: Math.max(2, Math.round(zone.h * outputHeight))
      };
    }

    function captureCurrentFinalCropCanvas() {
      if (!cropper || typeof cropper.getCroppedCanvas !== 'function') return null;
      var size = getFinalPhotoZoneSize();
      try {
        return cropper.getCroppedCanvas({
          width: size.width,
          height: size.height,
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high',
          fillColor: '#ffffff'
        });
      } catch (e) {
        return null;
      }
    }

    function getFinalCropCanvasOptions() {
      var mobile = !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
      return {
        maxWidth: mobile ? 1400 : 2200,
        maxHeight: mobile ? 1900 : 3000,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
        fillColor: '#ffffff'
      };
    }

    function refreshCartPreviewBeforeAdd() {
      if (!originalFile || !saved) return Promise.resolve();

      /* Do NOT ask Cropper to crop again here. The customer already approved a
         frame when Save Photo was pressed. Re-cropping at Add to Cart was a
         second opportunity for a hidden/mobile layout change to alter it. */
      var compositePromise;
      if (savedCompositeCanvas) {
        compositePromise = Promise.resolve(savedCompositeCanvas);
      } else if (automaticTransferBaseCanvas) {
        compositePromise = buildCompositeCanvas(automaticTransferBaseCanvas).then(function (canvas) {
          savedCompositeCanvas = canvas;
          return canvas;
        });
      } else {
        var emergencyCrop = captureCurrentFinalCropCanvas();
        if (!emergencyCrop) return Promise.reject(new Error('Could not prepare the final preview image.'));
        compositePromise = buildCompositeCanvas(emergencyCrop).then(function (canvas) {
          savedCompositeCanvas = canvas;
          return canvas;
        });
      }

      return compositePromise.then(function (finalCanvas) {
        var uploadCanvas = buildPreviewWithEngraving(finalCanvas);
        return new Promise(function (resolve, reject) {
          uploadCanvas.toBlob(function (blob) {
            if (!blob) {
              reject(new Error('Could not prepare the engraved preview image.'));
              return;
            }

            var editedFile = new File([blob], sanitizeFilename(originalFile.name) + '-cart-preview.png', {
              type: 'image/png',
              lastModified: Date.now()
            });

            uploadToCloudflare(cloudflareUploadEndpoint, editedFile, editedFile.name, 'preview', customizationId)
              .then(function (previewResult) {
                previewCloudUrl = previewResult.url || previewCloudUrl;
                if (previewResult.customization_id) customizationId = previewResult.customization_id;
                setUploadPropertyInputs();
                setFiles(editedInput, [editedFile]);
                resolve();
              })
              .catch(reject);
          }, 'image/png', 0.92);
        });
      });
    }

    function saveEdit() {
      if (!cropper || !originalFile) { showText(modalError, 'Choose a photo before saving.'); return; }
      saveBtn.disabled = true;
      saveBtn.textContent = 'Saving…';
      showText(modalError, '');

      /* Stage 7AB: never restore a separate/stale crop on Save. The CURRENT
         Cropper state is the frame the customer is looking at right now. Capture
         that exact state once at the crystal photo-zone resolution, then use the
         same canvas all the way through the product preview and cart upload. */
      commitCurrentCropFrame();
      renderLivePreviewMirror();
      var baseCanvas = captureCurrentFinalCropCanvas();
      if (!baseCanvas) {
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save photo';
        showText(modalError, 'Could not create the edited photo. Try another image.');
        return;
      }

      buildCompositeCanvas(baseCanvas).then(function (finalCanvas) {
        savedCompositeCanvas = finalCanvas;
        var uploadCanvas = buildPreviewWithEngraving(finalCanvas);

        /* Stage 7N: avoid finalCanvas.toDataURL() on mobile. It creates a large
           synchronous base64 string and can fail inside Shopify's mobile preview
           even though the canvas itself is valid. Blob URLs are lighter and are
           perfectly suitable for the on-page preview. */
        return Promise.all([canvasToPngBlob(finalCanvas), canvasToPngBlob(uploadCanvas)]).then(function (blobs) {
          var displayBlob = blobs[0];
          var blob = blobs[1];
          if (savedPreviewUrl && /^blob:/.test(savedPreviewUrl)) {
            try { URL.revokeObjectURL(savedPreviewUrl); } catch (e) {}
          }
          savedPreviewUrl = URL.createObjectURL(displayBlob);

          var editedFile = new File([blob], sanitizeFilename(originalFile.name) + '-edited.png', { type: 'image/png', lastModified: Date.now() });
          saveBtn.textContent = 'Uploading…';

          return uploadEditedAssets(editedFile).then(function () {
            setFiles(editedInput, [editedFile]);
            if (!isSecondary) {
              var mainImg = document.querySelector('.engoj_img_main');
              if (mainImg) {
                mainImg.src = savedPreviewUrl;
                lockProductGalleryPreview(savedPreviewUrl);
              }
              try {
                document.dispatchEvent(new CustomEvent('ll:image-editor:preview-saved', {
                  bubbles: true,
                  detail: { shape: shape, previewUrl: savedPreviewUrl, cloudPreviewUrl: previewCloudUrl, cloudOriginalUrl: originalCloudUrl, customizationId: customizationId }
                }));
              } catch (e) {}
            }
            if (photoName) photoName.textContent = originalFile.name + ' — uploaded and ready';
            if (editAgain) editAgain.hidden = false;
            setStatus('saved', 'Photo uploaded and ready.');
            if (!isSecondary && typeof root.__llPrepareMainPhotoTransfer === 'function') {
              root.__llPrepareMainPhotoTransfer().catch(function () {});
            }
            closeModal();
          }).catch(function (err) {
            showText(modalError, (err && err.message) ? err.message : 'Could not upload the image. Please try again.');
            setStatus('error', 'Image upload failed. Please try again.');
          }).finally(function () {
            saveBtn.disabled = false;
            saveBtn.textContent = 'Save photo';
          });
        });
      }).catch(function (err) {
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save photo';
        showText(modalError, 'Could not save the product preview on this device. Please try again or choose a smaller photo.');
      });
    }

    /* Stage 7V: real-phone file picker fix.
       Mobile Safari/Chrome can reject a file picker when the visible configurator
       button programmatically clicks a hidden helper button which then clicks the
       file input (two synthetic activation hops). Expose a direct picker method so
       the actual user click reaches the file input in the same activation stack. */
    function requestOriginalPhotoPicker(allowSameFile) {
      syncEditorConfiguration();
      if (!originalInput) return false;

      /* Stage 7AR: clear the native file input before a deliberate replacement
         so choosing the same file again still fires the change event. The
         current originalFile stays in memory if the customer cancels. */
      if (allowSameFile) {
        try { originalInput.value = ''; } catch (e) {}
      }

      /* showPicker() is the preferred mobile path when supported. It must run
         synchronously from the real user gesture, so callers must not wrap this
         in setTimeout/requestAnimationFrame/Promise callbacks. */
      try {
        if (typeof originalInput.showPicker === 'function') {
          originalInput.showPicker();
          return true;
        }
      } catch (e) {
        /* Some Safari versions expose showPicker but still require click(). */
      }

      try {
        originalInput.click();
        return true;
      } catch (e) {
        return false;
      }
    }

    root.__llRequestOriginalPhoto = requestOriginalPhotoPicker;
    root.__llOpenOrEditPhoto = function () {
      syncEditorConfiguration();
      if (originalFile) {
        bootCropper();
        return true;
      }
      return requestOriginalPhotoPicker();
    };

    trigger.addEventListener('click', function () { requestOriginalPhotoPicker(); });
    if (editAgain) editAgain.addEventListener('click', function () {
      if (originalFile) {
        syncEditorConfiguration();
        bootCropper();
      } else {
        requestOriginalPhotoPicker();
      }
    });

    root.addEventListener('ll:image-editor:configure', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (detail.shape) root.setAttribute('data-ll-editor-shape', detail.shape);
      if (detail.mask) root.setAttribute('data-ll-editor-mask', detail.mask);
      syncEditorConfiguration();
      loadImage(maskAsset).then(function () {
        resizeStage();
        if (cropper) { cropper.options.aspectRatio = getShapeConfig(shape).aspectRatio || SHAPE_CONFIG.default.aspectRatio; lockCropBox(); }
      }).catch(function () {});
      if (detail.reset) resetEditorState(detail.message || 'Customize the selected accessory.');
    });

    originalInput.addEventListener('change', function () {
      var file = originalInput.files && originalInput.files[0];
      if (!file) return;
      if (!/^image\//.test(file.type)) { showText(inlineError, 'Please choose an image file.'); return; }
      originalFile = file;
      automaticTransferBaseCanvas = null;
      savedCompositeCanvas = null;
      committedCropData = null;
      transferredPlacement = null;
      useDirectTransferDrag = false;
      directDragState = null;
      var activeStage = qsEditor('[data-ll-editor-stage]');
      if (activeStage) activeStage.classList.remove('ll-editor-stage--direct-drag', 'll-editor-stage--direct-dragging');
      clearCloudUploadState();
      if (editedInput) editedInput.value = '';
      if (photoName) photoName.textContent = file.name;
      setStatus('editing', 'Editing in progress — save the crop before adding to cart.');
      bootCropper();
    });

    qsaEditor('[data-ll-editor-close]').forEach(function (btn) { btn.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !modal.hidden) closeModal(); });

    var zoomOutBtn = qsEditor('[data-ll-editor-zoom-out]');
    var zoomInBtn = qsEditor('[data-ll-editor-zoom-in]');
    var rotateLeftBtn = qsEditor('[data-ll-editor-rotate-left]');
    var rotateRightBtn = qsEditor('[data-ll-editor-rotate-right]');
    var resetBtn = qsEditor('[data-ll-editor-reset]');
    var changePhotoBtn = qsEditor('[data-ll-editor-change-photo]');
    function rotateBy(delta) {
      if (!cropper) return;
      rotationDeg += delta;
      if (rotationDeg > 180 || rotationDeg < -180) rotationDeg = ((rotationDeg + 180) % 360 + 360) % 360 - 180;
      cropper.rotate(delta);
      if (rotationInput) rotationInput.value = String(rotationDeg);
      setTimeout(function () { lockCropBox(); commitCurrentCropFrame(); scheduleLivePreviewMirror(true); }, 40);
    }
    if (zoomOutBtn) zoomOutBtn.addEventListener('click', function () { if (cropper) { cropper.zoom(-0.14); positionMaskGuide(); setTimeout(commitCurrentCropFrame, 0); scheduleLivePreviewMirror(true); } });
    if (zoomInBtn) zoomInBtn.addEventListener('click', function () { if (cropper) { cropper.zoom(0.1); positionMaskGuide(); setTimeout(commitCurrentCropFrame, 0); scheduleLivePreviewMirror(true); } });
    if (rotateLeftBtn) rotateLeftBtn.addEventListener('click', function () { rotateBy(-10); });
    if (rotateRightBtn) rotateRightBtn.addEventListener('click', function () { rotateBy(10); });
    if (resetBtn) resetBtn.addEventListener('click', function () {
      if (!cropper) return;
      rotationDeg = 0;
      zoomPercent = 100;
      cropper.reset();
      setTimeout(function () {
        lockCropBox();
        if (useDirectTransferDrag) positionPhotoOverCropBox(null);
        commitCurrentCropFrame();
        scheduleLivePreviewMirror(true);
      }, 60);
      if (rotationInput) rotationInput.value = '0';
      if (zoomInput) zoomInput.value = '100';
    });
    if (changePhotoBtn) changePhotoBtn.addEventListener('click', function () {
      /* Stage 7AR: let the customer replace the source photo from inside the
         editor. Keep this call synchronous with the tap/click so real mobile
         browsers treat it as a valid file-picker user gesture. */
      requestOriginalPhotoPicker(true);
    });
    window.addEventListener('resize', function () {
      if (modal.hidden) return;

      var currentWidth = document.documentElement.clientWidth || window.innerWidth || 0;
      var mobile = !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);

      /* On phones, address-bar / browser-chrome changes often fire resize with
         the same layout width. Re-locking the crop box for those height-only
         changes is what caused the saved preview to drift/zoom. Ignore them. */
      if (mobile && lastEditorViewportWidth && Math.abs(currentWidth - lastEditorViewportWidth) < 3) {
        scheduleLivePreviewMirror(true);
        return;
      }

      lastEditorViewportWidth = currentWidth;
      var frameBeforeResize = null;
      if (cropper && typeof cropper.getData === 'function') {
        try { frameBeforeResize = cloneCropData(cropper.getData(true)); } catch (e) {}
      }
      resizeStage();
      if (cropper) {
        setTimeout(function () {
          resizeStage();
          lockCropBox();
          if (frameBeforeResize && typeof cropper.setData === 'function') {
            try { cropper.setData(frameBeforeResize); } catch (e) {}
          }
          commitCurrentCropFrame();
          scheduleLivePreviewMirror(true);
        }, 80);
      }
    });
    saveBtn.addEventListener('click', saveEdit);

    if (!isSecondary) form.addEventListener('submit', function (event) {
      if (!root.contains(trigger)) return;
      if (!saved || !editedInput.files || !editedInput.files.length || !originalCloudUrl || !previewCloudUrl) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        showText(inlineError, 'Please upload, save, and wait for the photo upload to finish before adding to cart.');
        emitStatus('error', 'Please personalize this product before adding to cart.');
        var visibleTrigger = document.querySelector('[data-ll-personalize-trigger]');
        if (visibleTrigger) visibleTrigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      if (cartSubmitInProgress) return false;
      cartSubmitInProgress = true;

      var button = form.querySelector('.enj-add-to-cart-btn') || form.querySelector('[type="submit"]');
      var oldButtonText = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.classList.add('is-adding');
        button.textContent = 'Preparing preview…';
      }

      refreshCartPreviewBeforeAdd()
        .catch(function (err) {
          /*
            Stage 6L:
            The extra "refresh preview before add-to-cart" upload is a final sync pass.
            If Cloudflare is momentarily unreachable here, do not block checkout when the
            saved original + saved preview URLs already exist from the previous Save Photo step.
          */
          if (originalCloudUrl && previewCloudUrl) {
            console.warn('[LL image editor] Preview refresh failed; using already saved preview.', err);
            return;
          }
          throw err;
        })
        .then(function () {
          if (button && oldButtonText) button.textContent = oldButtonText;
          /* Stage 7AQ audit: return the cart request promise. Previously this
             chain released cartSubmitInProgress immediately after starting
             /cart/add.js, so a second submit path could run before navigation. */
          return addToCartWithFiles(form);
        })
        .catch(function (err) {
          alert(err && err.message ? err.message : 'Could not prepare the engraved preview. Please try again.');
          if (button) {
            button.disabled = false;
            button.classList.remove('is-adding');
            if (oldButtonText) button.textContent = oldButtonText;
          }
        })
        .finally(function () {
          cartSubmitInProgress = false;
        });

      return false;
    }, true);
  }


  function removeDefaultNoneProperties(formData) {
    ['Light Base', 'Crystal Accessory'].forEach(function (name) {
      ['properties[' + name + ']', 'properties[_' + name + ']'].forEach(function (key) {
        var value = formData.get(key);
        if (String(value || '').toLowerCase() === 'none') formData.delete(key);
      });
    });
  }

  var SERVICE_ADDON_VARIANTS = {
    'Keep Background': 48609121501389,
    'Ultra HD Engraving': 48609121534157,
    'Gift Wrapping': 48609121566925
  };

  var LIGHTBASE_VARIANTS = {
    'Round Light Base': 39577453789389,
    'Small Wooden Light Base': 39822423785677,
    'Medium Wooden Light Base': 39822445510861,
    'Large Wooden Light Base': 39822456422605,
    'X-Large Wooden Light Base': 39822531920077
  };

  function parsePropertiesFromFormData(formData) {
    var properties = {};
    formData.forEach(function (value, key) {
      var match = /^properties\[(.*)\]$/.exec(key);
      if (!match) return;
      if (value == null || value === '') return;
      if (value instanceof File) return;
      var propertyName = match[1];
      if (/^_?Accessory\b/i.test(propertyName) || /^_?accessory_/i.test(propertyName) || /^_ll_accessory_/i.test(propertyName)) return;
      properties[propertyName] = String(value);
    });
    return properties;
  }

  function llEditorCentsToMoney(cents) {
    var value = (parseInt(cents || 0, 10) || 0) / 100;
    return '$' + value.toFixed(value % 1 === 0 ? 0 : 2);
  }

  function findConfiguratorForForm(form) {
    return (form && form.querySelector('[data-ll-configurator]')) || document.querySelector('[data-ll-configurator]');
  }

  function syncConfiguratorCartFields(form, formData) {
    var configurator = findConfiguratorForForm(form);
    if (!configurator || !formData) return;

    var selectedSize = configurator.querySelector('.ll-cfg-size.is-selected');
    if (selectedSize) {
      var variantId = selectedSize.getAttribute('data-ll-variant-id') || '';
      var sizeLabel = selectedSize.getAttribute('data-ll-size-label') || '';
      var sizePrice = parseInt(selectedSize.getAttribute('data-ll-variant-price') || '0', 10) || 0;

      if (variantId) {
        formData.set('id', variantId);

        if (form) {
          var idFields = form.querySelectorAll('[name="id"]');
          Array.prototype.forEach.call(idFields, function (field) {
            try {
              field.value = variantId;
              field.setAttribute('value', variantId);
              field.dispatchEvent(new Event('change', { bubbles: true }));
            } catch (e) {}
          });
        }
      }

      if (sizeLabel) { formData.set('properties[_Crystal Size]', sizeLabel); formData.delete('properties[Crystal Size]'); }
      if (sizePrice) formData.set('properties[_ll_selected_size_price]', llEditorCentsToMoney(sizePrice));
    }

    var selectedShape = configurator.querySelector('[data-ll-selected-shape-input]');
    if (selectedShape && selectedShape.value) {
      formData.set('properties[_Crystal Shape]', selectedShape.value); formData.delete('properties[Crystal Shape]');
    }
  }

  function getMainVariantId(formData, form) {
    syncConfiguratorCartFields(form, formData);
    var id = formData.get('id');
    var parsed = parseInt(id, 10);
    return parsed && isFinite(parsed) ? parsed : 0;
  }

  function getMainQuantity(formData) {
    var qty = parseInt(formData.get('quantity') || '1', 10);
    return qty && qty > 0 ? qty : 1;
  }

  function getSelectedServiceAddons(formData) {
    var selected = [];
    Object.keys(SERVICE_ADDON_VARIANTS).forEach(function (name) {
      var value = formData.get('properties[' + name + ']') || formData.get('properties[_' + name + ']');
      if (String(value || '').toLowerCase() === 'yes') {
        selected.push({
          name: name,
          variantId: SERVICE_ADDON_VARIANTS[name]
        });
      }
    });
    return selected;
  }

  function getSelectedLightBase(formData) {
    var selected = String(formData.get('properties[_Light Base]') || formData.get('properties[Light Base]') || '');
    if (!selected || selected.toLowerCase() === 'none') return null;

    var variantId = LIGHTBASE_VARIANTS[selected] || 0;
    if (!variantId) return null;

    return {
      name: selected,
      variantId: variantId
    };
  }

  function getSavedAccessories(form) {
    var configurator = findConfiguratorForForm(form);
    var saved = configurator && Array.isArray(configurator.__llAccessoryItems) ? configurator.__llAccessoryItems : [];
    return saved.map(function (item) {
      return {
        name: String(item.name || 'Crystal Accessory'),
        handle: String(item.handle || ''),
        shape: String(item.shape || ''),
        size: String(item.size || ''),
        variantId: parseInt(item.variantId || '0', 10) || 0,
        customizationId: String(item.customizationId || item.id || ''),
        originalUrl: String(item.originalUrl || ''),
        previewUrl: String(item.previewUrl || ''),
        cropData: String(item.cropData || ''),
        rotation: String(item.rotation || '0'),
        zoom: String(item.zoom || '100')
      };
    }).filter(function (item) {
      return item.variantId && item.customizationId && item.originalUrl && item.previewUrl;
    });
  }

  function buildCartItemsFromFormData(formData, form) {
    var mainVariantId = getMainVariantId(formData, form);
    var quantity = getMainQuantity(formData);
    var customizationId = String(formData.get('properties[_customization_id]') || '');
    var mainProperties = parsePropertiesFromFormData(formData);
    var selectedServices = getSelectedServiceAddons(formData);
    var selectedLightBase = getSelectedLightBase(formData);
    var selectedAccessories = getSavedAccessories(form);

    if (!mainVariantId) throw new Error('Could not find the selected product variant.');

    var items = [{
      id: mainVariantId,
      quantity: quantity,
      properties: mainProperties
    }];

    if (selectedLightBase && selectedLightBase.variantId) {
      items.push({
        id: selectedLightBase.variantId,
        quantity: quantity,
        properties: {
          '_customization_id': customizationId,
          '_addon_for': 'Custom Crystal',
          '_addon_type': 'lightbase',
          '_addon_name': selectedLightBase.name,
          '_parent_variant_id': String(mainVariantId)
        }
      });
    }


    selectedAccessories.forEach(function (selectedAccessory) {
      items.push({
        id: selectedAccessory.variantId,
        quantity: 1,
        properties: {
          '_customization_id': selectedAccessory.customizationId,
          '_addon_for': 'Custom Crystal',
          '_addon_type': 'customized_accessory',
          '_addon_name': selectedAccessory.name,
          '_Accessory Size': selectedAccessory.size,
          '_parent_customization_id': customizationId,
          '_parent_variant_id': String(mainVariantId),
          '_Original Photo URL': selectedAccessory.originalUrl,
          '_Preview Image': selectedAccessory.previewUrl,
          '_Edited Preview URL': selectedAccessory.previewUrl,
          '_pplr_preview': selectedAccessory.previewUrl,
          '_ll_editor_status': 'saved',
          '_ll_editor_version': 'stage-6t-multi-accessory-upsell-editor',
          '_ll_shape': selectedAccessory.shape,
          '_ll_crop_data': selectedAccessory.cropData,
          '_ll_rotation_deg': selectedAccessory.rotation,
          '_ll_zoom_percent': selectedAccessory.zoom,
          '_Accessory Original Photo URL': selectedAccessory.originalUrl,
          '_Accessory Preview Image': selectedAccessory.previewUrl
        }
      });
    });

    selectedServices.forEach(function (service) {
      if (!service.variantId) return;
      items.push({
        id: service.variantId,
        quantity: quantity,
        properties: {
          '_customization_id': customizationId,
          '_addon_for': 'Custom Crystal',
          '_addon_type': 'service',
          '_addon_name': service.name,
          '_parent_variant_id': String(mainVariantId)
        }
      });
    });

    return items;
  }

  function addToCartWithFiles(form) {
    var button = form.querySelector('.enj-add-to-cart-btn') || form.querySelector('[type="submit"]');
    if (button) { button.disabled = true; button.classList.add('is-adding'); }
    var formData = new FormData(form);
    formData.delete('properties[_ll_original_photo_file]');
    formData.delete('properties[Edited Photo]');
    formData.delete('properties[_ll_accessory_original_photo_file]');
    formData.delete('properties[_Accessory Edited Photo]');

    if (formData.get('properties[Crystal Size]') && !formData.get('properties[_Crystal Size]')) {
      formData.set('properties[_Crystal Size]', formData.get('properties[Crystal Size]'));
    }
    formData.delete('properties[Crystal Size]');

    if (formData.get('properties[Crystal Shape]') && !formData.get('properties[_Crystal Shape]')) {
      formData.set('properties[_Crystal Shape]', formData.get('properties[Crystal Shape]'));
    }
    formData.delete('properties[Crystal Shape]');

    if (formData.get('properties[Light Base]') && !formData.get('properties[_Light Base]')) {
      formData.set('properties[_Light Base]', formData.get('properties[Light Base]'));
    }
    formData.delete('properties[Light Base]');

    var engravingText = formData.get('properties[Engraving Text]');
    if (engravingText) {
      var engravingTextClean = String(engravingText).replace(/^\s+|\s+$/g, '');
      if (engravingTextClean) {
        formData.set('properties[Engraving Text]', '\n' + engravingTextClean);
      }
    }

    ['Keep Background', 'Ultra HD Engraving', 'Gift Wrapping'].forEach(function (name) {
      var visibleKey = 'properties[' + name + ']';
      var privateKey = 'properties[_' + name + ']';
      if (formData.get(visibleKey) && !formData.get(privateKey)) {
        formData.set(privateKey, formData.get(visibleKey));
      }
      formData.delete(visibleKey);
    });

    removeDefaultNoneProperties(formData);
    formData.delete('properties[Crystal Accessory]');
    formData.delete('properties[_Crystal Accessory]');

    var payload;
    try {
      syncConfiguratorCartFields(form, formData);
      payload = { items: buildCartItemsFromFormData(formData, form) };
    } catch (err) {
      alert(err && err.message ? err.message : 'Could not prepare cart items.');
      if (button) { button.disabled = false; button.classList.remove('is-adding'); }
      return Promise.resolve(false);
    }

    var addSucceeded = false;
    return fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (j) { throw new Error(j && (j.description || j.message) || 'Could not add to cart.'); });
      return res.json();
    }).then(function () {
      /* Stage 7X: the full cart page is the single cart experience on mobile
         and desktop. Keep the button locked until navigation so a slow phone
         cannot submit the same customized bundle more than once. */
      addSucceeded = true;
      if (button) {
        button.disabled = true;
        button.classList.add('is-adding');
        button.textContent = 'Opening cart…';
      }
      window.location.assign('/cart');
    }).catch(function (err) {
      alert(err && err.message ? err.message : 'Could not add to cart. Please try again.');
    }).finally(function () {
      if (!addSucceeded && button) {
        button.disabled = false;
        button.classList.remove('is-adding');
      }
    });
  }

  function blockLockedGalleryEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var gallery = target.closest('.detail-gallery.ll-preview-locked');
    if (!gallery) return;
    if (!target.closest('.gallery-control')) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  ['click', 'mousedown', 'touchstart', 'keydown'].forEach(function (type) {
    document.addEventListener(type, blockLockedGalleryEvent, true);
  });

  function initAll() { qsa(document, '[data-ll-image-editor]').forEach(initEditor); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
